export default __webpack_public_path__ + "assets/beachfront.2efbfd15.jpg";